<svg width="55" height="40" viewBox="0 0 55 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.51953 17.1721L20.006 34.4201L51.7995 3.06006" stroke="#0F9129" stroke-width="7.04"/>
</svg>
